/*
 * BBC - Rap Map - Get rappers from JSON data
 *
 * @author Matt Haynes <matt@joipolloi.com>
 * @package BBC Rap Map
 */

const d = new Date();
const date = d.getDate();
const hour = d.getHours();
const month = d.getMonth();

const getRappers = async (season) => {
    const path = `/rapmap/documents/db-season-${season}.json?version=${month}-${date}-${hour}`;

    try {
        const res = await fetch(path);

        return await res.json();
    } catch (err) {
        console.error('Error: ', err);
    }
};

export default getRappers;
